import { Editor, Node, Path, Transforms } from 'slate';

import * as serializer from 'basic-editor-value-serializer';

const types = serializer.types;
const layoutUtilities = serializer.utilities.node.layout;

export function countLayoutAncestors(editor, path) {

  let count = 0;

  for (const [ancestor] of Node.ancestors(editor, path)) {
    if (ancestor.type === types.LAYOUT) {
      count++;
    }
  }

  return count;

}

export function getParentLayout(editor, path) {

  if (path.length === 0) {
    return null;
  }

  const parent = Node.parent(editor, path);

  if (parent.type !== types.LAYOUT) {
    return null;
  }

  return parent;

}

export function isInRow(editor, path) {

  return layoutUtilities.isRowLayout(getParentLayout(editor, path)) === true;

}

export function fitsAt(layoutAncestorCount, nodes) {

  for (let index = 0; index < nodes.length; index++) {
    if (layoutUtilities.canNest(layoutAncestorCount, nodes[index]) === false) {
      return false;
    }
  }

  return true;

}

// The layout item settings belong to the position, so a wrapper placed at that position
// takes them over from the block it wraps.
export function moveItemSettings(editor, fromPath, toPath) {

  const properties = Node.get(editor, fromPath).properties || {};

  if (typeof properties.layoutItem === 'undefined') {
    return;
  }

  const remaining = { ...properties };
  delete remaining.layoutItem;

  Transforms.setNodes(editor, { properties: remaining }, { at: fromPath });

  const target = Node.get(editor, toPath);
  Transforms.setNodes(editor, { properties: { ...target.properties, layoutItem: properties.layoutItem } }, { at: toPath });

}

export function wrapInLayout(editor, path, layoutNode) {

  Editor.withoutNormalizing(editor, function wrap() {
    Transforms.wrapNodes(editor, { ...layoutNode, children: [] }, { at: path });
    moveItemSettings(editor, path.concat(0), path);
  });

  return path.concat(0);

}

export function wrapInStack(editor, path) {

  const stack = layoutUtilities.buildStackNode([serializer.utilities.node.paragraph.buildNode()]);

  return wrapInLayout(editor, path, stack);

}

// Rule 1: a block added after a block that sits directly in a row goes into an auto stack below
// it, so the row never gains an item. Returns null when the stack would break the depth limit.
export function insertAfterBlock(editor, path, nodes) {

  const count = countLayoutAncestors(editor, path);

  if (isInRow(editor, path) === false) {
    if (fitsAt(count, nodes) === false) {
      return null;
    }
    Transforms.insertNodes(editor, nodes, { at: Path.next(path) });
    return Path.next(path);
  }

  if (layoutUtilities.canNest(count + 1, Node.get(editor, path)) === false || fitsAt(count + 1, nodes) === false) {
    return null;
  }

  let insertedPath = null;

  Editor.withoutNormalizing(editor, function insertInStack() {
    const blockPath = wrapInStack(editor, path);
    insertedPath = Path.next(blockPath);
    Transforms.insertNodes(editor, nodes, { at: insertedPath });
  });

  return insertedPath;

}
